import featureFlags from '../constants/featureFlags';
import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: "promotions",
    tagSub: "promotions",
    exact: false,
    path: PATHS.PROMOTION.path,
    show: true,
    icon: "faTicketAlt",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.PROMOTION_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.BUNDLE_VIEW],
    children: [
        {
            title: "campaigns",
            group: "campaigns",
            path: PATHS.CAMPAIGN.LIST.path,
            tagSub: "promotions",
            exact: false,
            icon: 'faTicketAlt',
            // show: featureFlags.CAMPAIGN_ENABLED,
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.CAMPAIGN,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE,
                DEFINE.GENERAL.PERMISSION.DELETE,
            ],
            children: [
                {
                    title: "createCampaign",
                    group: "campaigns",
                    tagSub: "promotions",
                    path: PATHS.CAMPAIGN.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateCampaign",
                    group: "campaigns",
                    tagSub: "promotions",
                    path: PATHS.CAMPAIGN.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "promotionsManagerment",
            group: "promotions",
            path: PATHS.PROMOTION.LIST.path,
            tagSub: "promotions",
            exact: false,
            icon: 'faTicketAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.PROMOTION_MANAGEMENT,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.EXPORT,
                DEFINE.GENERAL.PERMISSION.UPDATE_STATUS,
                DEFINE.GENERAL.PERMISSION.BUNDLE_VIEW,
                DEFINE.GENERAL.PERMISSION.BUNDLE_CREATE,
                DEFINE.GENERAL.PERMISSION.BUNDLE_UPDATE,
                DEFINE.GENERAL.PERMISSION.DEACTIVE,
                DEFINE.GENERAL.PERMISSION.UPDATE_STATUS_BY_EXCEL,
            ],
            children: [
                {
                    title: "createGroupPromotions",
                    group: "promotions",
                    tagSub: "promotions",
                    path: PATHS.PROMOTION.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                },
                {
                    title: "updateGroupPromotions",
                    group: "promotions",
                    tagSub: "promotions",
                    path: PATHS.PROMOTION.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                },
            ]
        },
        {
            title: "checkPromotion",
            group: "checkPromotion",
            tagSub: "promotions",
            path: PATHS.PROMOTION.CHECK.path,
            exact: false,
            icon: 'check',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.PROMOTION_CHECKCODE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        },
        {   
            title: "autoFill",
            group: "autoFill",
            path: PATHS.AUTOFILL.LIST.path,
            tagSub: "promotions",
            exact: false,
            icon: 'code',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.AUTO_FILL,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.CREATE,
                DEFINE.GENERAL.PERMISSION.UPDATE,
                DEFINE.GENERAL.PERMISSION.DELETE,
            ],
            children: [
                {
                    title: "createAutoFill",
                    group: "autoFill",
                    tagSub: "autoFill",
                    path: PATHS.AUTOFILL.CREATE.path,
                    exact: false,
                    show: false,
                }, {
                    title: "updateAutoFill",
                    group: "autoFill",
                    tagSub: "autoFill",
                    path: PATHS.AUTOFILL.DETAIL.path,
                    exact: false,
                    show: false,
                }
            ]
        },
    ]
}]
